import { FullscreenControl } from 'maplibre-gl'

import { gettext } from '@bikemap/js/services'
import { setTooltip } from '@bikemap/js/utility'
import MapFeatureControl from './MapFeatureControl'

// Browsers use different event types
const FULLSCREEN_EVENT_TYPES = {
    onfullscreenchange: 'fullscreenchange',
    onmozfullscreenchange: 'mozfullscreenchange',
    onwebkitfullscreenchange: 'webkitfullscreenchange',
    onmsfullscreenchange: 'MSFullscreenChange',
}

/**
 * Offer fullscreen mode for the map.
 */
export default class FullscreenVew extends MapFeatureControl {

    /** @type {FullscreenControl} */
    _fullscreenControl

    /** @type {string} */
    _fullscreenEventType

    /**
     * @param {Object} [settings]
     * @param {import('./MapFeatureControl').MapFeaturePosition} [settings.position]
     */
    constructor(settings = {}) {
        super()

        if (settings.position) {
            this.setPosition(settings.position)
        }

        this._fullscreenControl = new FullscreenControl
        this._fullscreenEventType = this._findFullscreenEventType()

        this._handleFullscreenToggle = this._handleFullscreenToggle.bind(this)
    }

    _onAdd(map) {
        map.addControl(this._fullscreenControl, this.position)
        setTooltip('.maplibregl-ctrl-fullscreen', gettext('Toggle fullscreen'), this.tooltipPosition)
        document.addEventListener(this._fullscreenEventType, this._handleFullscreenToggle)
    }

    _onRemove(map) {
        map.removeControl(this._fullscreenControl)
        document.removeEventListener(this._fullscreenEventType, this._handleFullscreenToggle)
    }

    /**
     * Find the fullscreen event type supported by the current browser.
     * @returns {string}
     */
    _findFullscreenEventType() {
        for (const type in FULLSCREEN_EVENT_TYPES) {
            if (type in window.document) {
                return FULLSCREEN_EVENT_TYPES[type]
            }
        }
    }

    _handleFullscreenToggle(e) {
        // Resize is necessary in Safari to cover the whole screen
        this._map.resize()
        // Add a class in fullscreen mode to apply special CSS
        e.target.classList.toggle('fullscreen')
    }

}
